// Default buffer days per module (used when settings not yet loaded)
export const DEFAULT_BUFFERS = {
  buffer_itr: 10,
  buffer_tds_returns: 7,
  buffer_tds_payments: 3,
  buffer_gst: 5,
  buffer_audit: 15,
  buffer_roc: 7,
  buffer_esipf: 3,
  buffer_accounts: 5,
};

/**
 * Calculate internal due date = statutoryDate - bufferDays.
 * If result lands on Sunday (day 0), shift back to Saturday.
 * @param {string} statutoryDate  ISO date string e.g. "2026-07-31"
 * @param {number} bufferDays     days before statutory
 * @returns {string} ISO date string or "" if input invalid
 */
export function calcInternalDue(statutoryDate, bufferDays = 7) {
  if (!statutoryDate || isNaN(bufferDays)) return '';
  const d = new Date(statutoryDate);
  if (isNaN(d.getTime())) return '';
  d.setDate(d.getDate() - Number(bufferDays));
  // Shift Sunday → Saturday
  if (d.getDay() === 0) d.setDate(d.getDate() - 1);
  return d.toISOString().split('T')[0];
}

/**
 * Color class for internal due date cell.
 * status — string status of the record
 * COMPLETED_STATUSES — list of terminal statuses
 */
const COMPLETED_STATUSES = [
  'Filed', 'Acknowledged', 'Signed', 'Filed with Penalty', 'Filed with Late Fee', 'Paid', 'Paid Late',
];

export function internalDueColor(internalDate, status) {
  if (!internalDate) return 'text-gray-300';
  if (COMPLETED_STATUSES.includes(status)) return 'text-green-600';
  const diff = (new Date(internalDate) - new Date()) / 86400000;
  if (diff < 0) return 'text-red-600 font-semibold';      // overdue
  if (diff <= 3) return 'text-orange-600 font-semibold';  // ≤3 days
  if (diff <= 7) return 'text-yellow-600 font-semibold';  // ≤7 days
  return 'text-green-600';                                 // on track
}

export function internalDueBadge(internalDate, status) {
  if (!internalDate) return null;
  if (COMPLETED_STATUSES.includes(status)) return null;
  const diff = (new Date(internalDate) - new Date()) / 86400000;
  if (diff < 0) return '🔴';
  if (diff <= 3) return '🟠';
  if (diff <= 7) return '🟡';
  return '🟢';
}
